import { isStaging } from "@/lib/env";

/** Empty string disables that tag; unset uses the Nuxt production default. */
function readPublicId(value: string | undefined, fallback: string): string | null {
  if (value === "") return null;
  const trimmed = value?.trim();
  return trimmed || fallback;
}

export type GoogleAdsConversion = { conversionLabel: string; value: number; currency: string };

export type AnalyticsPublicConfig = {
  enabled: boolean;
  gaMeasurementId: string | null;
  gtmId: string | null;
  metaPixelId: string | null;
  gaManagedByGtm: boolean;
  /** Google Ads account; loaded as a destination of the GA4 Google tag (GT-WK5C7GSX). */
  googleAdsId: string | null;
  /** Conversion actions in that account (Google Ads → Goals → Conversions). */
  googleAdsConversions: {
    booking: GoogleAdsConversion;
    campaignForm: GoogleAdsConversion;
  };
};

/** Public measurement IDs (safe to expose in the client bundle). */
export function getAnalyticsPublicConfig(): AnalyticsPublicConfig {
  const disabled =
    isStaging() || process.env.NODE_ENV === "development" || process.env.NEXT_PUBLIC_ANALYTICS_ENABLED === "false";

  const gaMeasurementId = readPublicId(
    process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
    "G-83D7S13S5D",
  );
  const gtmId = readPublicId(process.env.NEXT_PUBLIC_GTM_ID, "GTM-TG423PGP");
  const metaPixelId = readPublicId(
    process.env.NEXT_PUBLIC_META_PIXEL_ID,
    "715568754845733",
  );

  const googleAdsId = readPublicId(process.env.NEXT_PUBLIC_GOOGLE_ADS_ID, "AW-18450737873");

  const hasAnyId = Boolean(gaMeasurementId || gtmId || metaPixelId);

  return {
    enabled: !disabled && hasAnyId,
    gaMeasurementId,
    gtmId,
    metaPixelId,
    // This published Nuxt container already installs this GA4 measurement ID.
    gaManagedByGtm: gtmId === "GTM-TG423PGP" && gaMeasurementId === "G-83D7S13S5D",
    googleAdsId,
    googleAdsConversions: {
      // "Bokat möte – kampanjsida" and "Skickat meddelande – kampanjsida".
      booking: { conversionLabel: "ixiSCPqt6qQdENHV_91E", value: 2000, currency: "SEK" },
      campaignForm: { conversionLabel: "8UrjCP2t6qQdENHV_91E", value: 1000, currency: "SEK" },
    },
  };
}
